const LangForgotPassword = {
	"forgotPassword._title": ["FORGOT PASSWORD", "ភ្លេច​លេខ​សម្ងាត់"],
	"forgotPassword.form.button._resetMyPassword": [
		"Reset My Password",
		"កំណត់​លេខ​សម្ងាត់​​​ឡើង​វិញ",
	],
	"forgotPassword._description": [
		`Please enter the email address you used to sign up for your Starbucks account. We will send you an email with information on how to reset your password.`,
		`សូម​បំពេញ​អាសយដ្ឋាន​អ៊ីម៉ែល​ ដែល​លោក​អ្នក​បាន​ប្រើ​សម្រាប់​បង្កើត​គណនី​​ Starbucks ។
		យើង​ខ្ញុំ​នឹង​ផ្ញើ​អ៊ីម៉ែល​​ភ្ជាប់​ជាមួយ​ព័ត៌មាន​ សម្រាប់​កំណត់​លេខ​សម្ងាត់​របស់​លោក​អ្នក​ឡើង​វិញ ។`,
	],
	"forgotPasswordWithPhone._description": [
		`Please enter the phone number you used to sign up for your Starbucks account. We will send you an email with information on how to reset your password.`,
		`សូម​បំពេញ​អាសយដ្ឋាន​អ៊ីម៉ែល​ ដែល​លោក​អ្នក​បាន​ប្រើ​សម្រាប់​បង្កើត​គណនី​​ Starbucks ។
		យើង​ខ្ញុំ​នឹង​ផ្ញើ​អ៊ីម៉ែល​​ភ្ជាប់​ជាមួយ​ព័ត៌មាន​ សម្រាប់​កំណត់​លេខ​សម្ងាត់​របស់​លោក​អ្នក​ឡើង​វិញ ។`,
	],
	"forgotPasswordWithPhone._resenotp": ["Resend OTP", "ផ្ញើរលេខ OTP ម្តងទៀត"],

	"forgotPasswordWithPhone._otp._title": [
		"Enter 4-digit recovery code",
		"បញ្ចូលលេខ៤ខ្ទង់ដែលយើងផ្ញើរទៅ",
	],
	"forgotPasswordWithPhone._otp._description": [
		"The recovery code has been sent to your mobile phone. Please enter the code",
		"យើងបានផ្ញើរលេខ៤ខ្ទង់រួចរាល់ សូមបញ្ចូល",
	],
	"forgotPasswordWithPhone._create._title": [
		"Create new password",
		"យើងបានផ្ញើរលេខ៤ខ្ទង់រួចរាល់ សូមបញ្ចូល",
	],
	"forgotPasswordWithPhone._create._description": [
		"Your new password must be different from previous used passwords.",
		"លេខសម្ងាត់ថ្មីត្រូវតែខុសពីលេខសម្ងាត់ចាស់",
	],
	"forgotPasswordWithPhone._changed._title": [
		"Password changed!",
		"លេខសម្ងាត់ត្រូវបានផ្លាស់ប្ដូរ",
	],
	"forgotPasswordWithPhone._changed._description": [
		"Your password has been changed successfully.",
		"លេខសម្ងាត់ត្រូវបានផ្លាស់ប្ដូរដោយជោគជ័យ",
	],
	"forgotPasswordWithPhone._backtosign": ["Back to sign in", "ត្រឡប់ទៅ ចូល"],
	"forgotPassword._popyp._title": ["Forgot password", "ភ្លេចលេខសម្ងាត់"],
	"forgotPassword._popyp._description": [
		"Select which contact detail should we use to reset your password.",
		"រើសព័ត៌មានដើម្បីបង្កើតលេខសម្ងាត់ថ្មី",
	],
	"forgotPassword._popyp._viamobile": ["Via mobile phone", "តាមលេខទូរសព្ទ"],
	"forgotPassword._popyp._viaemail": ["Via email", "តាមអ៊ីម៊ែល"],
}

export default LangForgotPassword



// WEBPACK FOOTER //
// ./src/resources/pages/LangForgotPassword.js